
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M59.998 24.187V49c0 1.376-.489 2.553-1.469 3.532C57.55 53.51 56.373 54 54.998 54h-46c-1.375 0-2.552-.49-3.531-1.468-.979-.98-1.469-2.156-1.469-3.532V24.187a16.604 16.604 0 003.157 2.72c7.541 5.125 12.718 8.718 15.53 10.781a73.045 73.045 0 002.892 2.046c.74.49 1.723.99 2.953 1.5 1.23.51 2.375.766 3.436.766h.063c1.063 0 2.209-.256 3.437-.765 1.23-.511 2.215-1.01 2.954-1.5a73.15 73.15 0 002.89-2.047c3.542-2.563 8.73-6.157 15.564-10.781a17.262 17.262 0 003.124-2.72zm0-9.187c0 1.646-.51 3.219-1.53 4.719a14.87 14.87 0 01-3.813 3.844C46.822 29 41.946 32.385 40.029 33.72c-.207.146-.65.463-1.327.953-.678.49-1.24.886-1.689 1.188-.448.302-.989.64-1.625 1.015a9.435 9.435 0 01-1.796.844c-.563.187-1.083.282-1.563.282h-.063c-.478 0-1-.095-1.562-.282a9.469 9.469 0 01-1.796-.844 31.894 31.894 0 01-1.625-1.015 63.887 63.887 0 01-1.687-1.188c-.678-.49-1.12-.807-1.33-.953a1519.361 1519.361 0 00-8.187-5.703 1529.899 1529.899 0 01-6.406-4.453c-1.292-.875-2.51-2.079-3.656-3.61-1.146-1.531-1.719-2.952-1.719-4.265 0-1.625.433-2.98 1.297-4.062C6.16 10.542 7.395 10 8.998 10h46c1.354 0 2.527.488 3.516 1.468.99.98 1.484 2.156 1.484 3.53z","fill-rule":"nonzero"}})])
          )
        }
      }
    